import { NavLink, Outlet } from 'react-router-dom';
import { SettingsIcon } from '@/lib/navigation';

import { PageHeader } from '@/components/layout/page-header';
import { cn } from '@/lib/utils';

const sections = [
  { title: 'General', to: '/settings', end: true },
  { title: 'Appearance', to: '/settings/appearance' },
  { title: 'Attendance', to: '/settings/attendance' }
];

/**
 * Shared layout for the Settings area: one header plus a horizontal
 * sub-navigation, with each section rendered as a nested route.
 * User management and admin audit live under /admin.
 */
export function SettingsLayout() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Settings"
        description="Workspace configuration."
        icon={SettingsIcon}
      />
      <nav aria-label="Settings sections" className="border-border flex gap-1 border-b">
        {sections.map((section) => (
          <NavLink
            key={section.to}
            to={section.to}
            end={section.end}
            className={({ isActive }) =>
              cn(
                'focus-visible:ring-ring -mb-px border-b-2 px-3 py-2 text-sm transition-colors focus-visible:ring-2 focus-visible:outline-none motion-reduce:transition-none',
                isActive
                  ? 'border-foreground text-foreground font-medium'
                  : 'text-muted-foreground hover:text-foreground border-transparent'
              )
            }
          >
            {section.title}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
